import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { publicFileURL } from 'src/app/services/apiRoutes';
import { LoadingService } from 'src/app/services/shared/loading.service';
@Component({
  selector: 'apc-admin-certification-type',
  templateUrl: './certification-type.component.html',
  styleUrls: ['./certification-type.component.scss'],
})
export class AdminSectionManagementCertificationTypeComponent implements OnInit {
  @Input() public form: any;
  @Input() public fileFormData: FormData;
  @Input() public fileRequired: boolean;
  public badgeImage;
  constructor(
    private loadingService : LoadingService
  ) {
    if(this.form == null || typeof this.form != typeof undefined){
      this.form = new UntypedFormGroup(
        {
          code:new UntypedFormControl(''),
          name:new UntypedFormControl(''),
          vendor:new UntypedFormControl(''),
          urlDescription:new UntypedFormControl(''),
          type:new UntypedFormControl(''),
          subtype:new UntypedFormControl(''),
          defaultExpiration:new UntypedFormControl(''),
          urlBadge:new UntypedFormControl('')
        });
    }
  }

  ngOnInit(): void {
    this.fileFormData.delete('file');
    if (this.form.value.urlBadge) {
      this.badgeImage = publicFileURL + '/' + this.form.value.urlBadge;
    }
  }

  handleFileInput(files: FileList) {
    this.form.markAsDirty();
    if (files.item(0)) {
      this.fileRequired = false;
      this.fileFormData.delete('file');
      var reader = new FileReader();
      reader.readAsDataURL(files[0]);

      reader.onload = (_event) => {
        this.badgeImage = reader.result;
      };
      this.fileFormData.append('file', files.item(0));
    }
    this.loadingService.fileLoading = true;
  }

  getClassEditForm(){
    return this.getEditForm()?'col-lg-6':'col-lg'
  }

  getEditForm(){
    if(typeof this.form.editForm != typeof undefined){
      return this.form.editForm;  
    }else{
      return false;
    }
  }

}
